import * as React from "react";
import { createComponent } from "@lit-labs/react";
import Component from "../../components/Stepper/sgds-stepper";

customElements.define("sgds-stepper", Component);

export default createComponent({
  react: React,
  tagName: "sgds-stepper",
  elementClass: Component,
  events: {
    onSgdsNextStep: "sgds-next-step",
    onSgdsPreviousStep: "sgds-previous-step",
    onSgdsLastStep: "sgds-last-step",
    onSgdsFirstStep: "sgds-first-step",
    onSgdsArrived: "sgds-arrived",
    onSgdsReset: "sgds-reset"
  }
});
